import { Typography, Box } from "@mui/material";
import { format } from "date-fns";
import { tr } from "date-fns/locale";
import useGlobal from "../util/Global";

const CustLabel = ({
    labelKey,
    label,
    value,
    formatType = "text",
    variant = "body2",
    basecolor = {},
    labelSx = {},
    valueSx = {},
    layout = "row", // "row" (default) or "column"
}) => {
    const { t } = useGlobal();

    let formattedValue = value;

    if (formatType === "date" && value) {
        formattedValue = format(new Date(value), "dd MMMM yyyy", { locale: tr });
    }

    return (
        <Box display="flex" flexDirection={layout} gap={0.5}>
            {(labelKey || label) && (
                <Typography variant={variant} sx={{ color: basecolor, ...labelSx }}>
                    {labelKey ? t(labelKey) : label}
                </Typography>
            )}
            {value && (
                <Typography variant={variant} sx={{ color: basecolor, ...valueSx }}>
                    {layout === "row" ? `: ${formattedValue}` : formattedValue}
                </Typography>
            )}
        </Box>
    );
};

export default CustLabel;
